import React from 'react';
import styled from 'styled-components';
import {
  Card,
  Grid,
  MenuItem,
  FormControl,
  Select,
  Typography
} from '@material-ui/core';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';

const StyledTitle = styled(Typography)`
  text-transform: uppercase;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 12px;
`;

const StyledForm = styled('div')`
  margin-top: 10px;
  .formControl {
    min-width: 130px;
    background-color: #ededed;
  }
`;

export interface JiraEffortCardProps {
  issue: any;
}

const JiraEffortCard: React.FC<JiraEffortCardProps> = ({ issue }) => {
  const overallEffort = issue.fields?.customfield_10042?.value || '';
  const businessEffort = issue.fields?.customfield_10044?.value || '';
  const techEffort = issue.fields?.customfield_10043?.value || '';
  const vendorEffort = issue.fields?.customfield_10045?.value || '';
  const CustomSelect: React.FC<{ title: string; value: any }> = ({
    title,
    value
  }) => {
    return (
      <StyledForm>
        <StyledTitle>{title}</StyledTitle>
        <FormControl className='formControl'>
          <Select value={value} style={{ paddingLeft: 10 }}>
            <MenuItem value=''>None</MenuItem>
            <MenuItem value='Low'>Low</MenuItem>
            <MenuItem value='Medium'>Medium</MenuItem>
            <MenuItem value='High'>High</MenuItem>
            <MenuItem value='Very High'>Very High</MenuItem>
          </Select>
        </FormControl>
      </StyledForm>
    );
  };

  return (
    <Card>
      <CardTitle>
        <AssignmentLateIcon />
        Effort
      </CardTitle>
      <CardContent padding='small'>
        <Grid container spacing={1}>
          <Grid container item xs={12} spacing={3}>
            <Grid item xs={3}>
              <CustomSelect title={'Overall Effort'} value={overallEffort} />
            </Grid>
            <Grid item xs={3}>
              <CustomSelect title={'Business Effort'} value={businessEffort} />
            </Grid>
            <Grid item xs={3}>
              <CustomSelect title={'Tech Effort'} value={techEffort} />
            </Grid>
            <Grid item xs={3}>
              <CustomSelect title={'Vendor Effort'} value={vendorEffort} />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default JiraEffortCard;
